/* =========================================================
SEMI LOCATOR — COCKPIT RECOVERY BUILD V7.1
FULL REPLACEMENT FOR sim-cockpit.js

PURPOSE:
- Restore the LAST KNOWN WORKING geometry
- Do NOT stack patches
- Do NOT use renamed road classes
- Keep .slxRoad, .slxRoadFallback, #slxLane exactly
- Add only the safe motion that worked
========================================================= */

(function(){

"use strict";

function run(){

function byId(id){
return document.getElementById(id);
}

function make(tag,className,id){
var el=document.createElement(tag);
if(className){ el.className=className; }
if(id){ el.id=id; }
return el;
}

var wrap=byId("slxCockpitWrap");
var speedEl=byId("slxSpeedVal");
var driveBtn=byId("slxStartDrive");
var pauseBtn=byId("slxPauseDrive");

if(!wrap){
alert("slxCockpitWrap not found");
return;
}

/* clear old run flags so a bad previous build cannot block this */
wrap.removeAttribute("data-slx-unified-v7");
wrap.removeAttribute("data-slx-speed-seller-v3");
wrap.removeAttribute("data-slx-force-geometry-v2");

if(wrap.getAttribute("data-slx-recovery-v71")==="yes"){
return;
}
wrap.setAttribute("data-slx-recovery-v71","yes");

/* =========================================================
REMOVE OLD CSS / OLD SCENE
========================================================= */

var cssIds=[
"slxForceGeometryCss",
"slxSpeedSellerCss",
"slxWorldPopStyles",
"slxUnifiedV7Css",
"slxRecoveryV71Css"
];

for(var ci=0;ci<cssIds.length;ci++){
var oldCss=byId(cssIds[ci]);
if(oldCss && oldCss.parentNode){
oldCss.parentNode.removeChild(oldCss);
}
}

var old=byId("slxRoadScene");
if(old && old.parentNode){
old.parentNode.removeChild(old);
}

/* =========================================================
CSS — EXACT WORKING GEOMETRY NAMES
========================================================= */

var style=make("style",null,"slxRecoveryV71Css");

style.innerHTML=
"html,body{overflow:hidden!important;background:#020611!important;}" +

"#slxCockpitWrap{position:relative!important;width:100%!important;height:100vh!important;overflow:hidden!important;background:radial-gradient(circle at center,#0b3d73 0%,#041120 42%,#020611 72%,#01040b 100%)!important;}" +

"#slxRoadScene{position:absolute!important;inset:0!important;overflow:hidden!important;perspective:1200px!important;z-index:1!important;pointer-events:none!important;}" +

".slxRoad{display:block!important;position:absolute!important;left:50%!important;bottom:-58%!important;width:92%!important;height:225%!important;transform:translateX(-50%) rotateX(70deg)!important;transform-origin:bottom center!important;background:linear-gradient(to bottom,#213544 0%,#0a1420 42%,#02050a 100%)!important;box-shadow:0 0 160px rgba(0,190,255,.34),inset 0 0 90px rgba(0,220,255,.12)!important;z-index:2!important;opacity:1!important;}" +

".slxRoadFallback{display:block!important;position:absolute!important;left:50%!important;bottom:-52%!important;width:62%!important;height:205%!important;transform:translateX(-50%) rotateX(70deg)!important;transform-origin:bottom center!important;background:linear-gradient(to bottom,rgba(60,100,120,.72),rgba(4,8,14,.98))!important;border-left:2px solid rgba(120,240,255,.45)!important;border-right:2px solid rgba(120,240,255,.45)!important;box-shadow:0 0 120px rgba(0,220,255,.24)!important;z-index:3!important;}" +

"#slxLane{display:block!important;position:absolute!important;left:50%!important;top:-30%!important;width:14px!important;height:330%!important;transform:translateX(-50%) rotateX(68deg)!important;transform-origin:bottom center!important;overflow:visible!important;z-index:10!important;}" +

".slxLaneLine{display:block!important;position:absolute!important;left:0!important;width:100%!important;height:115px!important;border-radius:40px!important;background:#eaffff!important;box-shadow:0 0 24px #7fe8ff,0 0 80px rgba(0,220,255,.95)!important;opacity:1!important;}" +

".slxEdge{display:block!important;position:absolute!important;bottom:-54%!important;width:5px!important;height:218%!important;background:#67efff!important;box-shadow:0 0 26px rgba(0,240,255,.95),0 0 110px rgba(0,240,255,.58)!important;z-index:8!important;}" +
".slxEdge.left{left:18%!important;transform:rotate(-10deg)!important;}" +
".slxEdge.right{right:18%!important;transform:rotate(10deg)!important;}" +

".slxTestMarker{position:absolute!important;width:10px!important;height:70px!important;border-radius:20px!important;background:#ffec7a!important;box-shadow:0 0 28px rgba(255,220,80,.9)!important;z-index:12!important;}" +

"#slxLeftHud,#slxSpeed,#slxDriveControls,.slxTopBar,#slxRightRail,#slxHorizon{z-index:80!important;}";

document.head.appendChild(style);

/* =========================================================
FORCE SCENE REBUILD
========================================================= */

var scene=make("div",null,"slxRoadScene");
wrap.insertBefore(scene,wrap.firstChild);

var road=make("div","slxRoad",null);
var fallback=make("div","slxRoadFallback",null);
var leftEdge=make("div","slxEdge left",null);
var rightEdge=make("div","slxEdge right",null);
var lane=make("div","slxLane","slxLane");

scene.appendChild(road);
scene.appendChild(fallback);
scene.appendChild(leftEdge);
scene.appendChild(rightEdge);
scene.appendChild(lane);

/* lane markers */
var lines=[];
for(var i=0;i<40;i++){
var line=make("div","slxLaneLine",null);
line.style.top=(i*175)+"px";
lane.appendChild(line);
lines.push(line);
}

/* yellow depth markers */
var markers=[];
for(var m=0;m<18;m++){
var marker=make("div","slxTestMarker",null);
marker.style.left=(m%2===0 ? "30%" : "68%");
marker.style.top=(m*360)+"px";
scene.appendChild(marker);
markers.push({
el:marker,
base:m*360
});
}

/* =========================================================
STATE
========================================================= */

var driving=false;
var targetSpeed=0;
var speed=0;
var offset=0;
var phase=0;

/* =========================================================
BUTTONS
========================================================= */

if(driveBtn){
driveBtn.addEventListener("click",function(e){
e.stopPropagation();
driving=true;
targetSpeed=72;
driveBtn.innerHTML="DRIVING";
driveBtn.style.background="linear-gradient(90deg,#1e5fff,#22c8ff)";
if(pauseBtn){ pauseBtn.innerHTML="PAUSE"; }
});
}

if(pauseBtn){
pauseBtn.addEventListener("click",function(e){
e.stopPropagation();
driving=false;
targetSpeed=0;
pauseBtn.innerHTML="PAUSED";
if(driveBtn){ driveBtn.innerHTML="DRIVE"; }
});
}

/* =========================================================
MASTER LOOP
========================================================= */

function loop(){

speed+=(targetSpeed-speed)*0.045;

if(speed<0.2 && targetSpeed===0){
speed=0;
}

if(speedEl){
speedEl.innerHTML=String(Math.round(speed));
}

offset+=speed*0.85;
phase+=0.018;

for(var i=0;i<lines.length;i++){
var y=((i*175)+offset)%7200;
var scale=0.55+(y/window.innerHeight)*0.42;
if(scale>1.45){ scale=1.45; }

lines[i].style.transform="translateY("+y+"px) scaleX("+scale+")";
lines[i].style.opacity=String(0.32+(scale*.48));
}

for(var m=0;m<markers.length;m++){
var my=(markers[m].base+(offset*1.15))%7600;
var sc=0.35+(my/window.innerHeight)*0.9;
if(sc>1.65){ sc=1.65; }

markers[m].el.style.transform="translateY("+my+"px) scale("+sc+")";
markers[m].el.style.opacity=String(0.22+Math.min(0.7,sc*.45));
}

var bob=Math.sin(phase)*(driving ? speed*.018 : .15);
var steer=Math.sin(phase*.55)*(driving ? .5 : .15);

var roadTransform="translateX(-50%) translateY("+bob+"px) rotateX(70deg) rotateZ("+steer+"deg)";
road.style.transform=roadTransform;
fallback.style.transform=roadTransform;

requestAnimationFrame(loop);
}

loop();

console.log("SLX COCKPIT RECOVERY V7.1 READY");

window.__SLX_COCKPIT_DEBUG__={
version:"Recovery V7.1",
drive:function(){
driving=true;
targetSpeed=72;
if(driveBtn){ driveBtn.innerHTML="DRIVING"; }
},
pause:function(){
driving=false;
targetSpeed=0;
if(pauseBtn){ pauseBtn.innerHTML="PAUSED"; }
if(driveBtn){ driveBtn.innerHTML="DRIVE"; }
},
state:function(){
return {
driving:driving,
speed:speed,
targetSpeed:targetSpeed,
offset:offset
};
}
};

}

if(document.readyState==="loading"){
document.addEventListener("DOMContentLoaded",run);
}else{
run();
}

})();